import { render, staticRenderFns } from "./budget.vue?vue&type=template&id=35679eae&"
import script from "./budget.vue?vue&type=script&lang=ts&"
export * from "./budget.vue?vue&type=script&lang=ts&"
import style0 from "./budget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports